import {
    GET_PATIENT_COMPLAINTS,
    GET_PATIENT_COMPLAINTS_SUCCESS,
    GET_PATIENT_COMPLAINTS_FAIL,
   

} from './actionTypes';

export const getPatientComplaintsRequest = (token) => ({
    type: GET_PATIENT_COMPLAINTS,
    payload: token,
});

export const getPatientComplaintsSuccess = (patientcomplaints) => ({
    type: GET_PATIENT_COMPLAINTS_SUCCESS,
    payload: patientcomplaints,
});

export const getPatientComplaintsFail = (error) => ({
    type: GET_PATIENT_COMPLAINTS_FAIL,
    payload: error,
});

// export const cancelAppointmentRequest = (token,id) => ({
//     type: CANCEL_APPPOINTMENT,
//     payload: {token,id},
// });

// export const cancelAppointmentSuccess = (Appointment) => ({
//     type: CANCEL_APPPOINTMENT_SUCCESS,
//     payload: Appointment,
// });

// export const cancelAppointmentFail = (error) => ({
//     type: CANCEL_APPPOINTMENT_FAIL,
//     payload: error,
// });


